import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Offcanvas } from "react-bootstrap";
export var KSidebarCloseType;
(function (KSidebarCloseType) {
    KSidebarCloseType["BACK"] = "back";
    KSidebarCloseType["CLOSE"] = "close";
})(KSidebarCloseType || (KSidebarCloseType = {}));
export const KSidebar = ({ title, show, closeType = KSidebarCloseType.CLOSE, background = false, onClose, children }) => {
    return (_jsxs(Offcanvas, { show: show, backdrop: background, scroll: true, onHide: () => (onClose ? onClose() : {}), keyboard: false, children: [_jsx(Offcanvas.Header, { closeButton: closeType === KSidebarCloseType.CLOSE, children: _jsxs(Offcanvas.Title, { children: [closeType === KSidebarCloseType.BACK && _jsx("i", { className: "fa-regular fa-lg fa-angle-left", onClick: () => (onClose ? onClose() : {}) }), "\u00A0", title] }) }), _jsx(Offcanvas.Body, { children: children })] }));
};
